const KEY = 'agency_platform_v1';
const API_PATH = '/api/clients';

function loadLocalClients() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
}

function saveLocalClients(clients) {
  try {
    localStorage.setItem(KEY, JSON.stringify(clients));
  } catch (e) {
    console.error('Local save failed', e);
  }
}

export async function loadClients() {
  const local = loadLocalClients();
  try {
    const res = await fetch(API_PATH, { cache: 'no-store' });
    if (!res.ok) throw new Error(`Load failed: ${res.status}`);

    const data = await res.json();
    const clients = Array.isArray(data.clients) ? data.clients : [];
    if (clients.length === 0 && local.length > 0) {
      // One-time migration path: seed D1 from existing browser data.
      await saveClients(local);
      return local;
    }
    saveLocalClients(clients);
    return clients;
  } catch (e) {
    // Fallback keeps the app usable while API/D1 is being configured.
    return local;
  }
}

export async function saveClients(clients) {
  try {
    const res = await fetch(API_PATH, {
      method: 'PUT',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ clients }),
    });
    if (!res.ok) throw new Error(`Save failed: ${res.status}`);
    saveLocalClients(clients);
  } catch (e) {
    // Keep local copy on network/API failures.
    saveLocalClients(clients);
    console.warn('Remote save failed, kept local copy', e);
  }
}

export function makeClient(name, clientId, pin, retainer, platforms) {
  return {
    id: String(Date.now()),
    name,
    clientId,
    pin,
    retainer,
    platforms,
    createdAt: new Date().toISOString(),
    sections: [
      {
        id: 'store-overview',
        label: 'Store Overview',
        items: [
          {
            id: `${Date.now()}-ov-1`,
            type: 'text',
            title: 'Start Here - Store Overview',
            body: 'High-level walkthrough of your storefront setup, theme structure, and where to find core controls.',
            link: '',
          },
          {
            id: `${Date.now()}-ov-2`,
            type: 'text',
            title: 'Custom Functionality',
            body: 'Summary of custom features and how they work day-to-day.',
            link: '',
          },
          {
            id: `${Date.now()}-ov-3`,
            type: 'text',
            title: 'App Breakdown',
            body: 'List of installed apps, what each app does, and key ownership notes.',
            link: '',
          },
        ],
      },
      {
        id: 'shopify-guides',
        label: 'Shopify Guides',
        items: [
          {
            id: `${Date.now()}-sg-1`,
            type: 'text',
            title: 'Editing your store',
            body: 'How to update homepage content, collections, product pages, and navigation safely.',
            link: '',
          },
          {
            id: `${Date.now()}-sg-2`,
            type: 'text',
            title: 'Dynamic Components',
            body: 'Guide to reusable sections/snippets and how to configure them.',
            link: '',
          },
          {
            id: `${Date.now()}-sg-3`,
            type: 'text',
            title: 'Shopify Guides',
            body: 'Curated Shopify docs for common management tasks and best practices.',
            link: 'https://help.shopify.com',
          },
          {
            id: `${Date.now()}-sg-4`,
            type: 'text',
            title: 'Store Maintenance',
            body: 'Routine checklist for content updates, QA, app health, and performance checks.',
            link: '',
          },
        ],
      },
      {
        id: 'store-support',
        label: 'Store Support',
        items: [
          {
            id: `${Date.now()}-ss-1`,
            type: 'text',
            title: 'Get Support',
            body: 'Best contact path for urgent issues, bug reports, and support requests.',
            link: '',
          },
          {
            id: `${Date.now()}-ss-2`,
            type: 'text',
            title: 'Boost Conversions',
            body: 'Recommended CRO opportunities and quick-win optimization priorities.',
            link: '',
          },
          {
            id: `${Date.now()}-ss-3`,
            type: 'text',
            title: 'Feedback & Testimonial',
            body: 'Share feedback on deliverables and submit a testimonial when ready.',
            link: '',
          },
        ],
      },
    ],
    onboarding: {
      signed: false,
      signedBy: '',
      signedAt: null,
      answers: {},
      logins: {},
      files: [],
      completedSteps: [],
    },
  };
}
